const PARAGRAPH_RELATED = (uuid: string, language: string) => `
  paragraphsDataUUID(uuid: "${uuid}", language: "${language}") {
    ... on Related {
      id
      header
      icon
      type
      uuid
      listing {
        nid
        author
        bodyListing
        categories {
          alias
          color
          name
          weight
        }
        featuredImage {
          alt
          horizontalCardImage
        }
        memberOnly
        pathAlias
        publishedOn
        statusCode
        summaryListing
        title
        ... on Article {
          authors {
            title
            pathAlias
          }
        }
      }
    }
  }
`;

export default PARAGRAPH_RELATED;
